import { Router, Link, browserHistory, withRouter } from 'react-router';
import { Table, Button, Breadcrumb, BPanel } from '@sketchpixy/rubix';
import React from 'react';

import { Meteor } from 'meteor/meteor';

import { Reactive } from '../common/Reactive.mixin.js';

import { Promotions } from '../../collections/flights-type/promotions';
import PromotionListComponent from './component-promotions-list';

@Reactive({
	subscriptions: ["flights-type"],
	promotions: Promotions.find({}),
})
export default class PromotionsListPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	renderPromotions() {
		return this.props.promotions.map((promotion) => (
			<PromotionListComponent key={promotion._id} promotion={promotion} />
		));
	}

	render() {
		return (
			<div> 
				<Breadcrumb>  
					<Breadcrumb.Item>
						Promotions
					</Breadcrumb.Item>
					<Breadcrumb.Item active>
						Liste des promotions
					</Breadcrumb.Item>
					<Breadcrumb.Item>
						<Link to="/promotions-add"><Button bsStyle="success">Ajouter</Button></Link>
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Liste des tarifs">
					<Table responsive>
						<thead>
							<tr>
								<th>Nom</th>
								<th>Date de création</th>
								<th>Dernière modification</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{this.renderPromotions()}
						</tbody>
					</Table>
				</BPanel>
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/universal/components/promotions/PromotionsList.page.js
 **/